import 'slider-pro/dist/js/jquery.sliderPro.min';

if($('#front_slider').length) {
    $(window).on('load',function(){
        $( '#front_slider' ).sliderPro({
            width: '100%',
            autoHeight:true,
            slideDistance:0,
            touchSwipe:true,
            responsive: true,
            keyboard: false,
            arrows: true,
            buttons: true,
            waitForLayers: false,
            fade: false,
            autoplay: true,
            autoScaleLayers: false,
        });
    });
}



// WEBPACK FOOTER //
// ./scripts/misc/slider_pro.js